(function(){
  function init(root){
    if (root.dataset.rsReady) return; root.dataset.rsReady = '1';
    var variants = {};
    try { variants = JSON.parse(root.querySelector('[data-rs-variants]').textContent); } catch(e) {}
    var useTiers = root.dataset.useTiers === 'true';
    var cartAdd = root.dataset.cartAdd || '/cart/add';
    var cartUrl = root.dataset.cartUrl || '/cart';

    var main = root.querySelector('[data-rs-main]');
    var thumbs = root.querySelectorAll('[data-rs-thumb]');
    function go(i){ main.scrollTo({ left: main.clientWidth * i, behavior: 'smooth' }); }
    function current(){ return Math.round(main.scrollLeft / Math.max(main.clientWidth, 1)); }
    thumbs.forEach(function(t){ t.addEventListener('click', function(){ go(+t.dataset.rsThumb); }); });
    var prev = root.querySelector('[data-rs-prev]'), next = root.querySelector('[data-rs-next]');
    var count = main ? main.children.length : 0;
    if (prev) prev.addEventListener('click', function(){ go((current() - 1 + count) % count); });
    if (next) next.addEventListener('click', function(){ go((current() + 1) % count); });
    if (main) main.addEventListener('scroll', function(){
      var i = current();
      thumbs.forEach(function(t){ t.setAttribute('aria-current', +t.dataset.rsThumb === i ? 'true' : 'false'); });
    }, { passive: true });

    var form = root.querySelector('form[action*="/cart/add"]');
    var idInput = root.querySelector('[data-rs-variant-input]');
    root.querySelectorAll('[data-rs-size-radio]').forEach(function(r){
      r.addEventListener('change', function(){ var v = variants[r.value]; if (v && idInput) idInput.value = v.id; });
    });

    /* Kaching Bundles: keep our size buttons hidden while Kaching's widget is on the page */
    var wait = root.querySelector('[data-rs-kaching-wait]');
    if (wait) {
      var sel = 'kaching-bundles-block, kaching-bundle, [class*="kaching"], [id*="kaching"]';
      var found = function(){ return root.querySelector(sel) || document.querySelector(sel); };
      if (!found()) {
        var obs = new MutationObserver(function(){ if (found()) { obs.disconnect(); clearTimeout(timer); } });
        obs.observe(document.body, { childList: true, subtree: true });
        var timer = setTimeout(function(){ obs.disconnect(); if (!found()) wait.hidden = false; }, 4000);
      }
    }

    var tiers = root.querySelectorAll('[data-rs-tier]');
    var stickyPrice = root.querySelector('[data-rs-sticky-price]');
    function activeTier(){ return root.querySelector('[data-rs-tier].is-active') || tiers[0]; }
    tiers.forEach(function(t){
      t.addEventListener('click', function(e){
        if (e.target.closest('select')) return;
        tiers.forEach(function(x){ x.classList.remove('is-active'); var r = x.querySelector('input[type=radio]'); if (r) r.checked = false; });
        t.classList.add('is-active');
        var r = t.querySelector('input[type=radio]'); if (r) r.checked = true;
        if (stickyPrice && t.dataset.price) stickyPrice.textContent = t.dataset.price;
      });
    });

    var btn = root.querySelector('[data-rs-atc]');
    var msg = root.querySelector('[data-rs-msg]');
    var label = btn ? btn.textContent : '';
    function addTiers(){
      var tier = activeTier();
      var counts = {};
      var selects = tier ? tier.querySelectorAll('[data-rs-size]') : [];
      if (selects.length) {
        for (var i = 0; i < selects.length; i++) {
          var v = variants[selects[i].value];
          if (!v || !v.available) { msg.textContent = 'Size ' + selects[i].value + ' is unavailable. Please pick another.'; return; }
          counts[v.id] = (counts[v.id] || 0) + 1;
        }
      } else {
        counts[idInput.value] = tier ? (+tier.dataset.qty || 1) : 1;
      }
      var items = Object.keys(counts).map(function(id){ return { id: +id, quantity: counts[id] }; });
      msg.textContent = '';
      btn.disabled = true; btn.textContent = 'Adding...';
      fetch(cartAdd + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function(r){ if (!r.ok) return r.json().then(function(j){ throw new Error(j.description || 'Could not add to cart'); }); return r.json(); })
        .then(function(){ window.location.href = cartUrl; })
        .catch(function(err){ msg.textContent = err.message; btn.disabled = false; btn.textContent = label; });
    }
    if (form && useTiers) form.addEventListener('submit', function(e){ e.preventDefault(); addTiers(); });
    var sAtc = root.querySelector('[data-rs-sticky-atc]');
    if (sAtc) sAtc.addEventListener('click', function(){
      if (useTiers) { addTiers(); return; }
      btn.scrollIntoView({ behavior: 'smooth', block: 'center' });
      setTimeout(function(){ btn.click(); }, 350);
    });

    var sticky = root.querySelector('[data-rs-sticky]');
    if (sticky && btn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function(entries){
        var e = entries[0];
        var show = !e.isIntersecting && e.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        if (sAtc) sAtc.tabIndex = show ? 0 : -1;
      }).observe(btn);
    }
  }
  function boot(){ document.querySelectorAll('[data-rs-product]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();